import React, { useCallback, useContext, useState } from 'react'
import { AssessmentDefs } from 'pages'
import { AssessmentDefDrawer } from 'pages/School/AssessmentDef'
import { CustomSection } from 'styles/GlobalStyle'
import { CreateBatteryContext } from './CreateBatteryContext'
import BatteryForm from './BatteryForm'
import { CreateBatteryStyles, WrapAssessments, WrapFormPanel } from './Style'

const CreateBattery = () => {
    const { selectedAssessmentDefs, setSelectedAssessmentDefs, assessmentFilters, setAssessmentFilters } = useContext(CreateBatteryContext)

    const [currentAssessmentDef, setCurrentAssessmentDef] = useState(null)
    const [openAssessmentDefDrawer, setOpenAssessmentDefDrawer] = useState(false)

    const openDrawer = useCallback((ass) => {
        setOpenAssessmentDefDrawer(true)
        setCurrentAssessmentDef(ass.id)
    }, [])

    return (
        <CreateBatteryStyles>
            <WrapAssessments>
                <AssessmentDefs
                    assessmentFilters={assessmentFilters}
                    setAssessmentFilters={setAssessmentFilters}
                    selectedAssessmentDefs={selectedAssessmentDefs}
                    setSelectedAssessmentDefs={setSelectedAssessmentDefs}
                    onSelectAssessment={openDrawer}
                    selectAssessment
                    multiple
                    showBattery={false}
                />
            </WrapAssessments>
            <WrapFormPanel>
                <CustomSection $bg>
                    <BatteryForm />
                </CustomSection>
            </WrapFormPanel>
            <AssessmentDefDrawer
                open={openAssessmentDefDrawer}
                handleDrawer={setOpenAssessmentDefDrawer}
                assessmentDefId={currentAssessmentDef}
            />
        </CreateBatteryStyles>
    )
}

export default CreateBattery
